import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { usePursuitHeader } from '../../pages/Capture/record/pursuitHooks';
import { LifecycleNodeKind, useLinkedNodes } from '../LinkedChips';
import { PURSUIT_NAV_GROUPS } from './pursuitNav';
import { RecordSidebar } from './RecordSidebar';
/** Pursuit record rail (FND-18, §4.1). Counts come from GetLinkedNodes, which returns only what the viewer may see. */ export function PursuitSidebar({ pursuitId }) {
    // GRW-15: the header read model (cache shared with the record layout) names the
    // pursuit and its customer for the identity sub-line "Pursuit · <customer>".
    const { data: header } = usePursuitHeader(pursuitId);
    const linked = useLinkedNodes(LifecycleNodeKind.PURSUIT, pursuitId);
    const counts = useMemo(()=>Object.fromEntries((linked.data?.counts ?? []).map((c)=>[
                c.key,
                c.count
            ])), [
        linked.data?.counts
    ]);
    const customer = header?.opportunity?.customer?.label;
    return /*#__PURE__*/ _jsx(RecordSidebar, {
        back: {
            label: 'All pursuits',
            href: '/capture'
        },
        basePath: `/capture/${pursuitId}`,
        counts: counts,
        groups: PURSUIT_NAV_GROUPS,
        name: header?.name || 'Pursuit',
        navigationLabel: "Pursuit navigation",
        subtitle: customer ? `Pursuit · ${customer}` : 'Pursuit'
    });
}
